import React, { useState, useEffect } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { withStyles, CircularProgress, Typography, Box } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import Dashboard from '../../../../layouts/Dashboard';
import ListLocationPrinters from '../../../../components/Global/LocationPrinters/List';

import { selectLocationUsersInitQuery, Location } from './queries';
import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const OrgListLocationStaff = ({ classes, history }: Props): React.ReactElement => {
  const { enqueueSnackbar } = useSnackbar();
  const [location, setLocation] = useState<Location>({
    devices: [],
  });

  const { data: locationUsersInitQuery, loading, error } = useQuery(selectLocationUsersInitQuery(), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && locationUsersInitQuery && locationUsersInitQuery.locations && locationUsersInitQuery.locations.length > 0) {
      setLocation(locationUsersInitQuery.locations[0]);
    }
    return () => {
      mounted = false;
    };
  }, [locationUsersInitQuery]);

  useEffect(() => {
    if (error) {
      enqueueSnackbar('Failed to load printers. Please try again.', { variant: 'error' });
    }
  }, [error, enqueueSnackbar]);

  const handleCreate = () => {
    history.push(`/loc/printers/create`);
  };

  const handleEdit = (id: string) => {
    history.push(`/loc/printers/${id}/edit`);
  };

  if (loading) {
    return (
      <Dashboard breadcrumbs={[{ label: 'Printers' }]}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Dashboard>
    );
  }

  if (error) {
    return (
      <Dashboard breadcrumbs={[{ label: 'Printers' }]}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <Typography color="error">Error loading printers: {error.message}</Typography>
        </Box>
      </Dashboard>
    );
  }

  return (
    <Dashboard breadcrumbs={[{ label: 'Printers' }]}>
      <ListLocationPrinters printers={location.devices || []} handleCreate={handleCreate} handleEdit={handleEdit} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(OrgListLocationStaff));
